import clsx from 'clsx';
import React, { useState } from 'react';

import messageIcon from 'images/directory/message_icon.svg';

import Button from '@components/ButtonLegacy';
import { useEventTracking } from '@hooks';
import { ClickTarget, click } from '@tracking';
import { CommentUser } from '@utils/backend-api/comments';

import MessageModal from '../MessageModal';
import styles from './styles.module.scss';

interface MessageUserButtonProps {
  className?: string;
  user: CommentUser;
  variant?: 'link';
}

function MessageUserButton({ className, user, variant }: MessageUserButtonProps) {
  const { trackEvent } = useEventTracking();
  const [messageUser, setMessageUser] = useState(false);
  const variantClassName = variant || 'default';

  const handleOpen = () => {
    setMessageUser(true);
    trackEvent(
      click({ clickTarget: ClickTarget.CommentMessage, clickText: 'Open', contentId: user.id })
    );
  };

  const handleClose = () => {
    setMessageUser(false);
    trackEvent(
      click({ clickTarget: ClickTarget.CommentMessage, clickText: 'Close', contentId: user.id })
    );
  };

  return (
    <>
      <Button
        className={clsx(styles.MessageUserButton, styles[`${variantClassName}Button`], className)}
        onClick={handleOpen}
        data-test="message-button"
        variant={variant}
      >
        {!variant && <img className={styles.messageIcon} src={messageIcon} />}
        <span>Message</span>
      </Button>
      {messageUser && <MessageModal user={user} onClose={handleClose} />}
    </>
  );
}

export default MessageUserButton;
